/* eslint-disable no-underscore-dangle */
import { inject, Injectable } from '@angular/core';
import { JsonHttpService } from './json-http.service';
import { map } from 'rxjs/operators';
import { FileSizeHelper } from '../utils';

@Injectable({
    providedIn: 'root'
})
export class FileHttpService {
  private jsonHttpService = inject(JsonHttpService);

  async upload<T>(url: string, files: File[], options?: any, useGenericErrorHandling = false): Promise<T> {
    options ??= {};
    options.headers ??= this.jsonHttpService.generateHeaders();
    options.headers = options.headers.delete('Content-Type'); // Remove any content-type so it will be set correct to multipart

    const input = files.reduce((formData, file) => { formData.append('file', file); return formData; }, new FormData());
    const totalSize = files.reduce((acc, f) => acc + f.size, 0);
    const maxUploadSize: number = await this.jsonHttpService.get('api/upload/get-max-file-size', null, useGenericErrorHandling).toPromise();
    if (totalSize > maxUploadSize) {
      throw new Error(`The size of the selected files are too large to upload. Allowed upload size: ${FileSizeHelper.humanFileSize(maxUploadSize)}`);
    }

    try {
      return await this.jsonHttpService.postRaw(url, input, options, useGenericErrorHandling).pipe(
        map((response: T) => response || null)
      ).toPromise();
    } catch (e) {
      this.checkForMaxContentLength(e);
      throw e;
    }
  }

  private checkForMaxContentLength(e: any): void {
    const errorMessage = 'File is too large! Increase the maximum upload-size by setting the maxRequestLength and maxAllowedContentLength in your web.config file.';
    if ((e.status === 404 && e._body?.toLowerCase().includes('404.13')) ||
      (e.status === 500 && e._body?.toLowerCase().includes('maximum request length exceeded'))) {
      throw new Error(errorMessage);
    }
  }
}
